import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './LanguageContext';

function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredLang, setHoveredLang] = useState(null);
  const containerRef = useRef(null);
  const navigate = useNavigate();
  const { language, changeLanguage } = useLanguage();

  const translations = {
    es: {
      idioma: "Idioma",
      menu: "Menú principal",
      contacto: "Reservas y contacto"
    },
    en: {
      idioma: "Language",
      menu: "Main Menu",
      contacto: "Bookings & Contact"
    },
    zh: {
      idioma: "语言",
      menu: "主菜单",
      contacto: "预订与联系"
    }
  };

  const t = translations[language];

  const containerStyle = {
    position: 'fixed',
    top: 20,
    right: 20,
    zIndex: 999,
  };

  const buttonStyle = {
    background: 'linear-gradient(135deg, #f2cf73, #b8892f)',
    color: '#17120d',
    fontSize: '28px',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 0 8px rgba(0,0,0,0.4)',
    border: 'none',
    cursor: 'pointer'
  };

  const menuStyle = {
    position: 'absolute',
    top: 'calc(100% + 10px)',
    right: 0,
    backgroundColor: '#111',
    color: '#fff',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    padding: '16px',
    width: '220px',
  };

  const langStyle = (lang) => ({
    cursor: 'pointer',
    padding: '4px 6px',
    fontWeight: language === lang ? 'bold' : 'normal',
    color: language === lang ? '#facc15' : '#fff',
    backgroundColor: hoveredLang === lang ? '#333' : 'transparent',
    borderRadius: '4px',
    transition: 'background-color 0.2s',
    marginBottom: '2px'
  });

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (!containerRef.current?.contains(event.target)) {
        setIsOpen(false);
        setHoveredLang(null);
      }
    };

    document.addEventListener('mousedown', handlePointerDown);

    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={containerStyle}
    >
      <button
        style={buttonStyle}
        onClick={() => {
          setIsOpen((prev) => !prev);
          setHoveredLang(null);
        }}
        aria-label="Open menu"
        aria-expanded={isOpen}
      >
        ☰
      </button>

      {isOpen && (
        <div style={menuStyle}>
          <div
            style={{ marginBottom: '8px', cursor: 'default', position: 'relative' }}
            onMouseEnter={() => setHoveredLang(null)}
          >
            <div style={{ marginBottom: '4px' }}>
              <span role="img" aria-label="Idioma">🌐</span> {t.idioma}
            </div>
            <div style={{ paddingLeft: '12px' }}>
              <div
                style={langStyle('es')}
                onClick={() => {
                  changeLanguage('es');
                  setIsOpen(false);
                }}
                onMouseEnter={() => setHoveredLang('es')}
                onMouseLeave={() => setHoveredLang(null)}
              >
                <span role="img" aria-label="Español">🇪🇸</span> Español
              </div>
              <div
                style={langStyle('en')}
                onClick={() => {
                  changeLanguage('en');
                  setIsOpen(false);
                }}
                onMouseEnter={() => setHoveredLang('en')}
                onMouseLeave={() => setHoveredLang(null)}
              >
                <span role="img" aria-label="English">🇬🇧</span> English
              </div>
              <div
                style={langStyle('zh')}
                onClick={() => {
                  changeLanguage('zh');
                  setIsOpen(false);
                }}
                onMouseEnter={() => setHoveredLang('zh')}
                onMouseLeave={() => setHoveredLang(null)}
              >
                <span role="img" aria-label="中文">🇨🇳</span> 中文
              </div>
            </div>
          </div>

          <div
            onClick={() => {
              navigate('/');
              setIsOpen(false);
            }}
            style={{ marginBottom: '8px', cursor: 'pointer' }}
          >
            <span role="img" aria-label="Inicio">🏠</span> {t.menu}
          </div>

          <div
            onClick={() => {
              navigate('/contacto');
              setIsOpen(false);
            }}
            style={{ marginBottom: '8px', cursor: 'pointer' }}
          >
            <span role="img" aria-label={t.contacto}>📍</span> {t.contacto}
          </div>
        </div>
      )}
    </div>
  );
}

export default HamburgerMenu;
